import { connect } from 'react-redux';
import { closeAlert, blockUserCheckBoxClicked, noteTextFieldChanged } from '../../reducers/alert.reducers';
import AlertDialog from './alert-dialog';

const mapStateToProps = state => ({
  open: state.alert.open,
  title: state.alert.title,
  message: state.alert.message,
  isOrderDeclineAlert: state.alert.isOrderDeclineAlert,
  note: state.alert.note,
  blockUser: state.alert.blockUser,
});

const mapDispatchToProps = dispatch => ({
  onAgree: () => dispatch(closeAlert(true)),
  onDismiss: () => dispatch(closeAlert(false)),
  blockUserCheckBoxClicked: () => dispatch(blockUserCheckBoxClicked()),
  noteTextFieldChanged: (newValue) => dispatch(noteTextFieldChanged(newValue)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertDialog);
